import React from 'react'
import {BsLinkedin, BsGithub} from 'react-icons/bs';
// import {FaFacebook} from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'> 
    <div>
        <a href='https://www.linkedin.com/in/dorothy-muhonja/' target="_blank"><BsLinkedin /></a>
    </div>

    {/*<div>
        <a href='#' target="_blank"><FaFacebook/></a>
        
  </div>*/}

    <div>
        <a href='https://github.com/dorothymuhonja' target="_blank"><BsGithub/></a>
        
    </div>
      
    </div>
  )
}

export default SocialMedia
